import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import React from "react";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

/**
 * @param id * @param props
 * @param name  string * @param props
 * @param className string * @param props
 * @param disabled  boolean* @param props
 * @param onClick function* @param props
 * @param url stirng * @param props
 * @param splitName  boolean
 * @returns {JSX.Element}
 * @constructor
 */

const CustomButtonLink = (props) => {
    const { id, name, className = '', disabled = false, onClick = null, url = '', splitName = true } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <button
            id={`btn_cbl_action_${id}`}
            className={`btn-custom-link flex-row ${className}`}
            disabled={disabled}
            onClick={(e) => {
                if (onClick !== null) onClick(e);
                if (url != '') navigate(url);
            }}
        >
            {splitName ?
                (() => {
                    const words = t(name).split(' ');
                    const pairs = [];

                    for (let i = 0; i < words.length; i += 2) {
                        pairs.push(words.slice(i, i + 2).join(' '));
                    }

                    return pairs.map((pair, index) => (
                        <React.Fragment key={index}>
                            {pair} <br />
                        </React.Fragment>
                    ));
                })()
                : t(name)
            }
        </button>
    );
};

export default CustomButtonLink


